import { motion } from "framer-motion";
import { Tractor, Scissors, Sprout, TreePine, Wrench } from "lucide-react";
import { SERVICES } from "@/lib/site";

const ICONS = { Tractor, Scissors, Sprout, TreePine, Wrench };

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};
const WHITE_BG = { backgroundColor: "#fff" };

export const Services = () => {
  return (
    <section id="services" className="py-20 lg:py-28 bg-cream scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.2em] uppercase text-lawn font-bold mb-3">What we do</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-ink">
            Everything your yard needs, done properly
          </h2>
          <p className="mt-4 text-ink-soft text-base sm:text-lg">
            From a quick weekly mow to a full property tidy-up — pick what you need and we'll handle the rest.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                {...reveal}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group bg-surface border border-line rounded-2xl p-7 hover:-translate-y-1 hover:shadow-xl hover:shadow-forest/10 transition-all duration-300"
                style={WHITE_BG}
              >
                <div className="w-14 h-14 rounded-xl bg-forest/8 flex items-center justify-center mb-5 group-hover:bg-lawn group-hover:text-cream text-forest transition-colors">
                  <Icon className="w-7 h-7" strokeWidth={1.8} />
                </div>
                <h3 className="font-heading text-xl font-bold text-ink">{s.label}</h3>
                <p className="mt-2 text-ink-soft leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
